import { createRouter, createWebHistory } from 'vue-router';
import SignupPage from './components/SignupPage.vue';
import LoginPage from './components/LoginPage.vue';
import DashboardPage from './components/DashboardPage.vue';
import ForgotPasswordPage from './components/ForgotPasswordPage.vue';
import OtpVerifyPage from './components/OtpVerifyPage.vue';
import ResetPassword from './components/ResetPassword.vue';
import PasswordResetSuccess from './components/PasswordResetSuccess.vue';
import PasswordResetFailed from './components/PasswordResetFailed.vue';
import TempPasswordVerify from './components/TempPasswordVerify.vue';
import ObjectDashboard from './components/ObjectDashboard.vue';
import PaymentSuccess from './components/PaymentSuccess.vue';
import PaymentFailed from './components/PaymentFailed.vue';

const routes = [
  // Catch-all route that redirects to home
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Login',
    component: LoginPage,
    meta: { requiresGuest: true }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: SignupPage,
    meta: { requiresGuest: true },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/forgot/password',
    name: 'ForgotPasswordPage',
    component: ForgotPasswordPage,
    meta: { requiresGuest: true },
  },
  {
    path: '/otp/verify',
    name: 'OtpVerifyPage',
    component: OtpVerifyPage,
    meta: { requiresGuest: true },
  },
  {
    path: '/reset/password',
    name: 'ResetPasswordPage',
    component: ResetPassword,
    meta: { requiresGuest: true },
  },
  {
    path: '/reset/success',
    name: 'passwordResetSuccess',
    component: PasswordResetSuccess,
    meta: { requiresGuest: true },
  },
  {
    path: '/reset/failed',
    name: 'PasswordResetFailed',
    component: PasswordResetFailed,
    meta: { requiresGuest: true },
  },
  {
    path: '/temppass/verify',
    name: 'TempPasswordVerify',
    component: TempPasswordVerify,
    meta: { requiresGuest: true },
  },
  {
    path: '/dashboard/object/:id/:objectName',
    name: 'ObjectDashboard',
    component: ObjectDashboard,
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
  },
  {
    path: '/payment/failed',
    name: 'PaymentFailed',
    component: PaymentFailed,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('SESSION_TOKEN');

  if (to.meta.requiresAuth && !isAuthenticated) {
    // Redirect unauthenticated users trying to access protected routes
    next({ name: 'Login' });
  } else if (to.meta.requiresGuest && isAuthenticated) {
    // Redirect authenticated users trying to access guest-only routes
    next({ name: 'Dashboard' });
  } else {
    // Proceed to the route
    next();
  }
});

export default router;